import React from 'react';
import { Link } from 'react-router-dom';

// Shown for unknown routes and for known routes whose param (book, course, issue...) does not exist.
export default function NotFound() {
  return (
    <div className="navMargin" style={{ height: '100%' }}>
      <section
        className="notFound"
        style={{
          backgroundColor: '#352a35',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 30,
          textAlign: 'center',
        }}
      >
        <p style={{ color: 'white', fontSize: '24pt', fontWeight: 'bold', fontFamily: 'Source Sans Pro' }}>
          Página no encontrada
        </p>
        <p style={{ color: '#929292', fontSize: '16pt', fontFamily: 'Source Sans Pro' }}>
          La página que buscas no existe o fue movida.
        </p>
        <Link to="/" style={{ color: '#e4e400', fontSize: '16pt', fontFamily: 'Source Sans Pro' }}>
          Volver al inicio
        </Link>
      </section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/notFound.js